import React from "react";
import { Box, Card } from "@bca/ui-library";
import { layout, LayoutProps } from "styled-system";
import styled from "styled-components";

import AnimatedBox from "./AnimatedBox";

const StyledCard = styled(Card)<LayoutProps>`
  ${layout}
`;

const MobileSkeletonCard = ({
  display,
}: {
  display?: LayoutProps["display"];
}) => (
  <StyledCard
    width="auto"
    height="auto"
    paddingX={0}
    paddingY={0}
    marginX={0}
    marginY={0}
    display={display}
    data-testid="container"
  >
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      width="auto"
      data-testid="container2"
      minHeight="610px"
    >
      <AnimatedBox
        width="auto"
        height="260px"
        data-testid="image-skel"
        borderBottomLeftRadius="0px"
        borderBottomRightRadius="0px"
      />
      <Box
        data-testid="middle-skel"
        display="flex"
        flexDirection="column"
        flex="1 0 auto"
        padding={4}
        height="auto"
        mr="43px"
      >
        <Box display="flex" flexDirection="row" mb="31px">
          <AnimatedBox width="100px" height="12px" mr={4} />
          <AnimatedBox width="100px" height="12px" />
        </Box>
        <AnimatedBox maxWidth="280px" height="16px" mb={9} />
        <Box
          display="flex"
          flexDirection="row"
          flexWrap="wrap"
          justifyContent="space-between"
          mb={9}
        >
          <Box display="flex" flexDirection="column">
            <Box display="flex" flexDirection="row" alignItems="center" mb={5}>
              <AnimatedBox width="18px" height="18px" mr={2} />
              <AnimatedBox width="80px" height="13px" />
            </Box>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              mb="10px"
            >
              <AnimatedBox width="18px" height="18px" mr={2} />
              <AnimatedBox width="80px" height="13px" />
            </Box>
          </Box>
          <Box display="flex" flexDirection="column">
            <Box display="flex" flexDirection="row" alignItems="center" mb={5}>
              <AnimatedBox width="18px" height="18px" mr={2} />
              <AnimatedBox width="80px" height="13px" />
            </Box>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              mb="10px"
            >
              <AnimatedBox width="18px" height="18px" mr={2} />
              <AnimatedBox width="80px" height="13px" />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        backgroundColor="#F2F5F7"
        padding={4}
        display="flex"
        alignItems="flex-end"
        width="auto"
        minHeight="70px"
        data-testid="end-skel"
      ></Box>
    </Box>
  </StyledCard>
);

export default MobileSkeletonCard;
